/* eslint-disable react/no-deprecated */
import Iframe from 'react-iframe';
import { withRouter } from 'react-router-dom';
import { Paper, Title } from '../../components';
import { UNIT } from '../../constants';

function SalesService() {
  return (
    <div className='px-4 pb-4'>
      <Title title="Assistance" />
      <Paper className='col-12 px-0'>
        <div className="px-4 pb-4">
          <div className='pt-4'>
            <Iframe
              url='https://noteforms.com/forms/vous-avez-besoin-daide-3wqvs8'
              width='100%'
              height={`${UNIT * 51}`}
              id='myId'
              className='border-0 mt-5'
            />
          </div>
        </div>
      </Paper>
    </div>
  );
}
export default (withRouter(SalesService));